// The Users list guide (09_ListUsers.jsx · ModuleHelp, Max 01/11).
const en = {
  actionsT: 'Account tools',
  actionsB: 'Create new opens the form for a new account; Entities manages the company and vendor groups; Access requests lists people asking for an account.',
  filtersT: 'Find people',
  filtersB: 'Search by name, username or email. Group by entity folds the list under each company, and the count shows active accounts only.',
  tableT: 'The accounts',
  tableB: 'One row per account with roles, department and entity. Click a column title to sort or filter it; tick rows to set the entity for several people at once.',
  rowT: 'Open, edit or delete',
  rowB: 'The eye opens the profile, the pencil edits roles, department and entity, and the bin deletes the account.',
};
const ko = {
  actionsT: '계정 도구',
  actionsB: '새로 만들기는 새 계정 양식을 열고, Entities는 회사·벤더 그룹을 관리하며, 접근 요청은 계정을 요청한 사람 목록을 보여줍니다.',
  filtersT: '사람 찾기',
  filtersB: '이름, 사용자명, 이메일로 검색합니다. Entity별 그룹은 회사별로 목록을 접어 보여 주며, 건수는 활성 계정만 셉니다.',
  tableT: '계정 목록',
  tableB: '계정당 한 행에 역할, 부서, Entity가 표시됩니다. 열 제목을 클릭해 정렬·필터하고, 행을 체크해 여러 명의 Entity를 한 번에 지정할 수 있습니다.',
  rowT: '열기, 수정, 삭제',
  rowB: '눈 아이콘은 프로필을, 연필은 역할·부서·Entity 수정을, 휴지통은 계정 삭제를 실행합니다.',
};
const vi = {
  actionsT: 'Công cụ tài khoản',
  actionsB: 'Tạo mới mở form tạo tài khoản; Entities quản lý nhóm công ty và vendor; Yêu cầu truy cập liệt kê những người đang xin tài khoản.',
  filtersT: 'Tìm người',
  filtersB: 'Tìm theo tên, username hoặc email. Nhóm theo entity gom danh sách dưới từng công ty, và số đếm chỉ tính tài khoản đang hoạt động.',
  tableT: 'Danh sách tài khoản',
  tableB: 'Mỗi dòng là một tài khoản kèm role, phòng ban và entity. Bấm tiêu đề cột để sắp xếp hoặc lọc; tick nhiều dòng để gán entity cho nhiều người cùng lúc.',
  rowT: 'Xem, sửa hoặc xóa',
  rowB: 'Biểu tượng con mắt mở hồ sơ, cây bút sửa role, phòng ban và entity, thùng rác xóa tài khoản.',
};
const zh = {
  actionsT: '账号工具',
  actionsB: '新建会打开新账号表单；Entities 用来管理公司和供应商分组；访问申请列出正在申请账号的人。',
  filtersT: '查找人员',
  filtersB: '可按姓名、用户名或邮箱搜索。按 entity 分组会把列表折叠到各公司下，计数只统计启用的账号。',
  tableT: '账号列表',
  tableB: '每个账号一行，显示角色、部门和 entity。点击列标题可排序或筛选；勾选多行可一次为多人设置 entity。',
  rowT: '查看、编辑或删除',
  rowB: '眼睛图标打开个人资料，铅笔编辑角色、部门和 entity，垃圾桶删除账号。',
};
const dictionary = { ns: 'tourUsers', en, ko, vi, zh };
export default dictionary;
